"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DonutChart = void 0;

var _palette = require("@artsy/palette");

var _d3Interpolate = require("d3-interpolate");

var _d3Shape = require("d3-shape");

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ChartHoverTooltip = require("../DataVis/ChartHoverTooltip");

var _ChartTooltip = require("../DataVis/ChartTooltip");

var _MousePositionContext = require("../DataVis/MousePositionContext");

var _useWrapperWidth = require("../DataVis/utils/useWrapperWidth");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var colors = ["black10", "black30", "black60"];
var MIN_CHART_SIZE = 30;

/**
 * DonutChart is a component that displays data points with donut shaped arcs.
 * Good for illustrating numerical proportions.
 */
var DonutChart = function DonutChart(_ref) {
  var points = _ref.points,
      _ref$margin = _ref.margin,
      margin = _ref$margin === void 0 ? (0, _palette.space)(3) : _ref$margin;

  var _useState = (0, _react.useState)(-1),
      _useState2 = _slicedToArray(_useState, 2),
      hoverIndex = _useState2[0],
      setHoverIndex = _useState2[1];

  var wrapperRef = (0, _react.useRef)(null);
  var width = Math.max((0, _useWrapperWidth.useWrapperWidth)(wrapperRef), MIN_CHART_SIZE); // width of the arc is %12 of chart width

  var donutWidth = width * 0.12; // margin between chart and labels step down to 10px when chart is smaller than 230px

  var donutLabelMargin = width > 230 ? (0, _palette.space)(2) : (0, _palette.space)(1); // 2px in radians

  var padAngel = Math.atan(2 / width);
  var centerX = width / 2 + margin;
  var centerY = width / 2 + margin;
  var values = points.map(function (d) {
    return d.value;
  });
  var angelInterpolator = (0, _d3Interpolate.interpolate)(0, 2 * Math.PI);
  var arc = (0, _d3Shape.arc)().innerRadius(width / 2 - margin - donutWidth).outerRadius(width / 2 - margin).padAngle(padAngel); // virtual donut to use its arc centroids to calculate label position

  var labelArc = (0, _d3Shape.arc)().innerRadius(width / 2 - margin + donutLabelMargin).outerRadius(width / 2 - margin + donutLabelMargin);
  var pie = (0, _d3Shape.pie)().value(function (d) {
    return d.value;
  });
  var tooltip = points.map(function (point, index) {
    var hover = hoverIndex === index;
    return hover ? /*#__PURE__*/_react.default.createElement(_ChartHoverTooltip.ChartHoverTooltip, {
      key: "".concat(index, "-hover")
    }, (0, _ChartTooltip.coerceTooltip)(point.tooltip)) : null;
  });
  var labels = pie(points).map(function (slice, index) {
    var _labelArc$centroid = labelArc.centroid(slice),
        _labelArc$centroid2 = _slicedToArray(_labelArc$centroid, 2),
        x = _labelArc$centroid2[0],
        y = _labelArc$centroid2[1];

    var axisLabelX = points[index].axisLabelX;
    return axisLabelX && /*#__PURE__*/_react.default.createElement(DonutLabelContainer, {
      key: index,
      x: x + centerX,
      y: y + centerY,
      center: centerX
    }, /*#__PURE__*/_react.default.createElement(_palette.Text, {
      color: "black60",
      variant: "xs"
    }, (0, _ChartTooltip.coerceTooltipWithoutPadding)(axisLabelX)));
  });
  var zeroStateArc = pie([{
    value: 1
  }]).map(function (zeroState) {
    return /*#__PURE__*/_react.default.createElement("path", {
      key: "zero-state",
      stroke: "none",
      fill: (0, _palette.color)("black5"),
      d: arc(zeroState)
    });
  });
  var angle = angelInterpolator(1);
  pie.endAngle(angle);
  var slices = pie(points).map(function (datum, index) {
    // d3 by default sorts slices by values. for color assignment we
    // need sorted index but for hover we need original order in points
    // to match with correct tooltip
    var sortedIndex = datum.index;
    var arcColor = (0, _palette.color)(colors[sortedIndex % colors.length]); // avoid the first and last arc ending up the same color

    if (sortedIndex === values.length - 1 && sortedIndex % colors.length === 0) {
      arcColor = (0, _palette.color)(colors[1]);
    }

    return /*#__PURE__*/_react.default.createElement("path", {
      key: index,
      fill: arcColor,
      d: arc(datum),
      onMouseEnter: function onMouseEnter() {
        return setHoverIndex(index);
      },
      onMouseLeave: function onMouseLeave() {
        return setHoverIndex(-1);
      }
    });
  });
  return /*#__PURE__*/_react.default.createElement(_MousePositionContext.ProvideMousePosition, null, /*#__PURE__*/_react.default.createElement(_palette.Box, {
    ref: wrapperRef,
    position: "relative"
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, tooltip, width !== MIN_CHART_SIZE && labels, /*#__PURE__*/_react.default.createElement("svg", {
    key: "svg",
    width: width + margin,
    height: width + margin
  }, /*#__PURE__*/_react.default.createElement("g", {
    transform: "translate(".concat(centerX, ", ").concat(centerY, ")")
  }, zeroStateArc, /*#__PURE__*/_react.default.createElement("g", null, slices))))));
};

exports.DonutChart = DonutChart;
DonutChart.displayName = "DonutChart";

// to create a float:right effect for labels that are on left side (also top)
var computeLabelTranslate = function computeLabelTranslate(dim, center) {
  var diffPercent = (dim - center) / center;

  if (diffPercent < -0.25) {
    return "-100%";
  } else if (diffPercent < -0 && diffPercent > -0.25) {
    return "-50%";
  } else {
    return "0";
  }
};

var DonutLabelContainer = _styledComponents.default.div.withConfig({
  displayName: "DonutChart__DonutLabelContainer",
  componentId: "sc-1ieod6t-0"
})(["top:", "px;left:", "px;position:absolute;text-align:center;transform:translate( ", ",", " );white-space:nowrap;"], function (_ref2) {
  var y = _ref2.y;
  return y;
}, function (_ref3) {
  var x = _ref3.x;
  return x;
}, function (_ref4) {
  var x = _ref4.x,
      center = _ref4.center;
  return computeLabelTranslate(x, center);
}, function (_ref5) {
  var y = _ref5.y,
      center = _ref5.center;
  return computeLabelTranslate(y, center);
});
//# sourceMappingURL=DonutChart.js.map